import { Icon, Colors } from '@cognite/cogs.js';
import styled from 'styled-components/macro';

export const CommentStateGreenIcon = styled(Icon)`
  color: ${Colors['decorative--green--500']};
`;

export const CommentStateRedIcon = styled(Icon)`
  color: ${Colors['decorative--red--500']};
`;
